import styled from "styled-components";
import { Text } from "@mantine/core";
import sachin from "../assets/team/sachin.webp";
import sahil from "../assets/team/sahil.webp";
import shubham from "../assets/team/shubham.webp";
import meetgardi from "../assets/team/meet-gardi.webp";
import sharman from "../assets/team/shaman.webp"

// Outer wrapper
const OuterContainer = styled.div`
  color: white;
  background-color: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 2rem;
`;

// Container for all cards
const CardContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 2rem 0%;

  @media (max-width: 868px) {
    flex-direction: column;
    align-items: center;
  }
`;

// Individual Team Card
const Card = styled.div`
  background-color: transparent;
  border-radius: 15px;
  width: 18%;
  text-align: center;
  border: 1px solid rgb(167, 140, 76);
  transition: all 0.3s ease;

  &:hover {
    background-color: rgb(167, 140, 76);
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 868px) {
    width: 100%;
    margin-bottom: 1.5rem;
  }
`;

// Image style
const Image = styled.img`
  width: 100%;
  object-fit: cover;
  margin-bottom: 0rem;
  border-radius: 15px;
`;

// Name style
const Name = styled.h3`
  color: rgb(167, 140, 76);
  font-size: 1.6rem;
  margin-bottom: 0.3rem;
  transition: all 0.3s ease;
  margin-top: 0px;
  ${Card}:hover & {
    color: white;
  }
`;

// Position style
const Position = styled.p`
  color: #aaa;
  font-size: 1.1rem;
  margin: 0;
  transition: all 0.3s ease;
  margin-bottom: 0.5rem;

  ${Card}:hover & {
    color: white;
  }
`;

const ResponsiveTitle = styled(Text)`
  font-size: 3rem;
  font-weight: 500;
  font-family: "Paris Avenue";
  margin-top: 5rem;

  @media (max-width: 768px) {
    font-size: 2rem;
      margin-top: 3rem;
  }
`;

const Team = () => {
  const teamMembers = [
    {
      name: "Meet Gardi",
      position: "Founder & CEO",
      image: meetgardi,
    },
    {
      name: "Sachin Kumar",
      position: "Senior Real Estate Consultant",
      image: sachin,
    },
    {
      name: "Shaman Sharma",
      position: "Real Estate Advisor",
      image: sharman,
    },
    {
      name: "Shubham Verma",
      position: "Real Estate Advisor",
      image: shubham,
    },
    {
      name: "Sahil Gera",
      position: "Chief Marketing Officer",
      image: sahil,
    },
    
  ];

  return (
    <OuterContainer id="team">
      <ResponsiveTitle weight={700}>Meet Our Team</ResponsiveTitle>
      <Text
        weight={500}
        style={{
          fontSize: "1.2rem",
          textAlign: "center",
          maxWidth: "700px",
          marginBottom: "2rem",
          fontFamily: "Paris Avenue",
        }}
      >
        Our dedicated team of real estate professionals in Dubai is here to
        guide you with expertise, integrity, and a personalized touch.
      </Text>

      <CardContainer>
        {teamMembers.map((member, index) => (
          <Card key={index}>
            <Image src={member.image} alt={member.name} />
            <Name>{member.name}</Name>
            <Position>{member.position}</Position>
          </Card>
        ))}
      </CardContainer>
    </OuterContainer>
  );
};

export default Team;
